import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import { Shield, Lock, Server, CheckCircle } from 'lucide-react';
import './LandingPage.css';

export default function SecurityPage() {
  console.log('SecurityPage: before useTranslation');
  const { t } = useTranslation();
  console.log('SecurityPage: after useTranslation');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page">
      <SEO 
        title={t('common.security')} 
        description={t('security.learnHowReviioProtectsYourData')}
      />
      <SiteHeader variant="solid" />

      <main className="lp-main security-main">
        <div className="lp-container security-container">
          <div className="lp-section-header security-header">
            <h1 className="lp-section-title security-title">{t('security.securityAtReviio')}</h1>
            <p className="lp-section-subtitle security-subtitle">{' ' + t('security.weTakeTheSecurityAndPrivacy')}
            </p>
          </div>

          <div className="security-features">
            <div className="security-feature">
              <div className="security-icon">
                <Shield size={32} />
              </div>
              <div>
                <h3 className="security-feature-title">{t('security.dataEncryption')}</h3>
                <p className="security-feature-text">{' ' + t('security.allDataIsEncryptedInTransit')}
                </p>
              </div>
            </div>

            <div className="security-feature">
              <div className="security-icon">
                <Lock size={32} />
              </div>
              <div>
                <h3 className="security-feature-title">{t('security.authenticationAccess')}</h3>
                <p className="security-feature-text">{' ' + t('security.weEmployStrictAccessControlsAnd')}
                </p>
              </div>
            </div>

            <div className="security-feature">
              <div className="security-icon">
                <Server size={32} />
              </div>
              <div>
                <h3 className="security-feature-title">{t('security.infrastructureSecurity')}</h3>
                <p className="security-feature-text">{' ' + t('security.ourInfrastructureIsHostedOnEnterprise')}
                </p>
              </div>
            </div>

            <div className="security-feature">
              <div className="security-icon">
                <CheckCircle size={32} />
              </div>
              <div>
                <h3 className="security-feature-title">{t('security.compliance')}</h3>
                <p className="security-feature-text">{' ' + t('security.reviioProcessesDataInAccordanceWith')}
                </p>
              </div>
            </div>
          </div>

          <div className="security-vulnerability-card">
            <h3 className="security-vulnerability-title">{t('security.reportAVulnerability')}</h3>
            <p className="security-vulnerability-text">{' ' + t('security.ifYouBelieveYouHaveFound')}
            </p>
            <a href="mailto:security@reviio.app" className="lp-pricing-cta gradient security-vulnerability-btn">{' ' + t('security.contactSecurityTeam')}
            </a>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
